import type { ReviewMode } from './review-mode'

export const PROMPT_CATEGORIES = [
  'Document Analysis',
  'Content Drafting',
  'Content Editing & Improvement',
  'Content Transformation',
  'Data & Content Updates',
  'Quality Control',
  'Review',
  'Abbreviations',
  'China',
  'Japan',
] as const

export type PromptCategory = (typeof PROMPT_CATEGORIES)[number]

// Languages the backend can localize prompts into; other UI locales (e.g. Japanese) fall back to English.
export const PROMPT_LANGUAGES = ['en', 'zh'] as const

export type PromptLanguage = (typeof PROMPT_LANGUAGES)[number]

export const DEFAULT_PROMPT_LANGUAGE: PromptLanguage = 'en'

export function resolvePromptLanguage(uiLanguage?: string | null): PromptLanguage {
  return PROMPT_LANGUAGES.includes(uiLanguage as PromptLanguage)
    ? (uiLanguage as PromptLanguage)
    : DEFAULT_PROMPT_LANGUAGE
}

export interface Prompt {
  promptId: string
  title: string
  description: string
  category?: PromptCategory
  userPrompt: string
  systemPrompt?: string
  llmModel: string
  promptType: string
  isFavorite: boolean
  reviewMode: ReviewMode | null
  /** Attach existing document comments as read-only context without review mode. */
  requiresDocumentComments: boolean
  requiresFullDocument: boolean
}
